import { fetchApi } from './api';

// Fetch all hotspots
export const getHotspots = async () => {
  return fetchApi('/hotspots', { method: 'GET' });
};

// Create new hotspot
export const createHotspot = async (hotspotData) => {
  return fetchApi('/hotspots', {
    method: 'POST',
    body: hotspotData,
  });
};

// Update existing hotspot
export const updateHotspot = async (id, hotspotData) => {
  return fetchApi(`/hotspots/${id}`, {
    method: 'PUT',
    body: hotspotData,
  });
};

// Delete hotspot
export const deleteHotspot = async (id) => {
  return fetchApi(`/hotspots/${id}`, {
    method: 'DELETE',
  });
};
